<script>
  import { Button, DataTable, Link, Loading, TooltipIcon } from 'carbon-components-svelte';
  import { JsonView } from '@zerodevx/svelte-json-view';

  import TrashCan16 from 'carbon-icons-svelte/lib/TrashCan16';
  import NotAvailable from 'carbon-icons-svelte/lib/NotAvailable16';

  import { getTotalDateString } from '../../../../shared/date-utils';

  export let paths,
    tableHeaders,
    removePath = () => {},
    fetchingSizes = false,
    perPathDetails = {},
    pathAction = null;

  function handleLinkClick(event, row) {
    event.preventDefault();
    event.stopPropagation();
    pathAction(row);
  }

  $: expandable = paths.some(({ id }) => perPathDetails[id]);
  $: nonExpandableRowIds = paths.filter(({ id }) => !perPathDetails[id]).map((path) => path.id);
</script>

<div class="table" class:expandable>
  <!-- eslint-disable-next-line svelte/no-reactive-reassign -->
  <DataTable headers={tableHeaders} rows={paths} size="short" bind:expandable {nonExpandableRowIds}>
    <span slot="cell" let:cell let:row>
      {#if cell.key === 'actions'}
        <Button
          kind="danger-ghost"
          size="small"
          iconDescription="Remove"
          icon={TrashCan16}
          tooltipPosition="left"
          on:click={removePath(row.id)}
        />
      {:else if cell.key === 'lifetime' && row.path.startsWith('p-lseg-ll-feeds')}
        <em>Not supported</em>
      {:else if cell.key === 'restoring'}
        <strong>{getTotalDateString({ from: row.from, to: row.to })}</strong>
      {:else if cell.key === 'totalFiles' || cell.key === 'totalFileSize'}
        {#if cell.value !== null}
          {cell.display(cell.value, row)}
        {:else if fetchingSizes}
          <Loading withOverlay={false} small={true} />
        {:else}
          <TooltipIcon
            portalTooltip
            tooltipText="Will appear once the restore job is triggered or sizes are requested"
            direction="top"
            align="start"
            icon={NotAvailable}
          />
        {/if}
      {:else if cell.key === 'path' && pathAction}
        <Link href="javascript:void(0);" on:click={(event) => handleLinkClick(event, row)}>
          {cell.value}
        </Link>
      {:else if cell.display}
        {cell.value ? cell.display(cell.value, row) : '—'}
      {:else}
        {cell.value ?? '—'}
      {/if}
    </span>
    <svelte:fragment slot="expandedRow" let:row>
      <JsonView json={perPathDetails[row.id]} />
    </svelte:fragment>
  </DataTable>
  {#if !paths.length}
    <div class="empty">No selections made yet.</div>
  {/if}
</div>

<style>
  .table:not(.expandable) :global(.bx--data-table tr td:first-child),
  .table.expandable :global(.bx--data-table tr td:nth-child(2)) {
    max-width: 250px;
    overflow-y: auto;
    text-wrap: nowrap;
  }

  .table :global(.bx--data-table tr .bx--btn--danger-ghost) {
    min-height: 1rem !important;
  }

  .table :global(.bx--data-table tr .bx--btn--danger-ghost svg) {
    margin-left: unset;
  }

  .empty {
    color: var(--cds-text-helper);
    pointer-events: none;
    width: 100%;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--cds-layer);
  }

  .table :global(.bx--expandable-row .bx--child-row-inner-container) {
    max-height: 200px !important;
    overflow-y: auto;
  }

  .table :global(li span.key) {
    color: var(--cds-text-secondary);
  }
</style>
